export const Form = {
  idenTipoAto: "",
  descTipoAto: "",
  siglTipoAto: "",
};

const url = "/tipoatos";
const id = "descTipoAto";

export function buscarPeloCodigo(codigo) {
  return new Promise((resolve, reject) => {
    window.$http.get(`${url}/${codigo}`).then((res) => {
      resolve(res.data);
    });
  });
}

export function buscaPersonalizada(filtro) {
  return new Promise((resolve, reject) => {
    window.$http.get(`${url}/buscaPersonalizada?${filtro}`).then((res) => {
      resolve(res.data);
    });
  });
}

export function pesquisarAllTipoAto(paginacao) {
  return new Promise((resolve, reject) => {
    window.$http.get(`${url}/allPageable?${paginacao}`).then((res) => {
      resolve(res.data);
    });
  });
}

export function pesquisarAtivos() {
  return new Promise((resolve, reject) => {
    window.$http.get(`${url}/ativos`).then((res) => {
      resolve(res.data);
    });
  });
}

export function salvar(parm) {
  return new Promise(async (resolve, reject) => {
    if (parm[id] && parm[id] !== 0) {
      await atualizar(parm).then((res) => {
        resolve({ ...res, type: "UPD" });
      });
    } else {
      await criar(parm).then((res) => {
        resolve({ ...res, type: "INS" });
      });
    }
  });
}

export function remover(data) {
  return new Promise((resolve, reject) => {
    window.$http.delete(`${url}/${data}`).then((res) => {
      resolve();
    });
  });
}

export function atualizar(parm) {
  return new Promise((resolve, reject) => {
    window.$http.put(`${url}/${parm[id]}`, JSON.stringify(parm)).then((res) => {
      resolve(res.data);
    });
  });
}

export function criar(parm) {
  return new Promise((resolve, reject) => {
    window.$http.post(`${url}`, JSON.stringify(parm)).then((res) => {
      resolve(res.data);
    });
  });
}
